import e from "../managers/braze-instance.js";
import { getByteLength as U } from "../util/string-utils.js";
import r from "../../shared-lib/braze-shared-lib.js";
import { User } from "../User/index.js";
import { validateStandardString as J } from "../util/validation-utils.js";
export function changeUser(i, t) {
  if (!e.rr()) return;
  if (null == i || 0 === i.length || i != i)
    return void r.j.error("changeUser requires a non-empty userId.");
  if (U(i) > User.lr)
    return void r.j.error(
      `Rejected user id "${i}" because it is longer than ${User.lr} bytes.`,
    );
  if (null != t && !J(t, "set signature for new user", "signature")) return;
  const s = e.cr();
  s && s.changeUser(i.toString(), e.gr(), t);
}
